import $ from "jquery";
import deparam from "jquery-deparam";
import Cookies from "js-cookie";

const enhance_tracking_links = () => {
  const domain = document.referrer ? (new URL(document.referrer)).hostname : null;
  const is_reviewed = domain && domain == "reviewed.com"
  const referrer = is_reviewed ? Cookies.get("og_referrer") : document.referrer;
  const extra_params = deparam(document.location.search.slice(1));
  const extra_params_string = Cookies.get("extra_params") || $.param(extra_params);
  Cookies.set("og_referrer", referrer)
  Cookies.set("extra_params", extra_params_string)

  $('a[href*="/affiliates/"]').each((i, el) => {
    $(el).attr("href", `${$(el).attr("href")}&og_referrer=${encodeURIComponent(referrer)}&${extra_params_string}`);
  })
}

// DOM RELATED METHODS
const inject_category_into_tracking = category => {
  if (category !== "reviewed") {
    return $('a[href*="/affiliates/"]').each((i, el) => {
      if (!$(el).attr("href").includes("&category="))
        $(el).attr("href", `${$(el).attr("href")}&category=${category}`);
    });
  }
};

const handle_conversion_tracking = (el) => {
  $(el).click(function(event) {
    event.stopPropagation;
    event.preventDefault();
    const url = get_url(this)
    let gtagPromise = window.gtag_report_conversion(url);
    let opened = false;
    let windowReference = window.open()

    const link = new URL(url);

    const retailer = link.searchParams.get("retailer");
    const headline = window.js_vars.content_headline || "No Article"

    window.dataLayer.push({
      "event" : "affiliate-link-click",
      headline : retailer
    });

    Promise.all([gtagPromise]).then(() => {
      console.log("Opening off-site affiliate link (main promise resolution)");
      opened = true;
      windowReference.location = url
    }).finally(() => {
      if (!opened) {
        console.log("Opening off-site affiliate link (from finally)");
        windowReference.location = url
      }
    });
  });
};

const set_conversion_tracking = () => {
  $('a.conversion, a[href*="/affiliates/"], [data-click-tracking]').each((i, el) => {
    handle_conversion_tracking(el)
  });
};

const get_url = (el) => {
  let type = el.nodeName
  if (type == "DIV"){
    return $("[data-click-tracking]").attr("data-affiliate-link")
  } else if (type == "A"){
    return el.href
  }
}

const run = () => {
  inject_category_into_tracking(window.js_vars.website_id);
  enhance_tracking_links();
  set_conversion_tracking();
};

export default Object.freeze({ run });
